// LISTING TABLE STATES
export const SET_LISTING_TAB = "SET_LISTING_TAB";
export const SET_PAGE_NUMBER = "SET_PAGE_NUMBER";
export const SET_PAGE_SIZE = "SET_PAGE_SIZE";
export const SET_ASSIGNED_TO = "SET_ASSIGNED_TO";
export const SET_ENROLLMENT_STATUS = "SET_ENROLLMENT_STATUS";
export const SET_PROGRAM_VALUE = "SET_PROGRAM_VALUE";
export const SET_MOBILE_APP_ACTIVITY_VALUE = "SET_MOBILE_APP_ACTIVITY_VALUE";
export const SET_ADDED_ON_VALUE = "SET_ADDED_ON_VALUE";
export const SET_UNENROLLMENT_REASON_VALUE = "SET_UNENROLLMENT_REASON_VALUE";
export const SET_UNENROLLED_BY_VALUE = "SET_UNENROLLED_BY_VALUE";
export const SET_SENT_CREDENTIALS = "SET_SENT_CREDENTIALS";
export const SET_EDUCATION_GIVEN = "SET_EDUCATION_GIVEN";
export const SET_CARE_PLAN = "SET_CARE_PLAN";
export const SET_INITIATING_VISIT = "SET_INITIATING_VISIT";
export const SET_CONSENT_STATUS = "SET_CONSENT_STATUS";
export const SET_ADDED_VIA = "SET_ADDED_VIA";
export const SET_QUERY = "SET_QUERY";
export const SET_CPT_CODES_ITEMS = "SET_CPT_CODES_ITEMS";
export const SET_SORTED_ITEMS = "SET_SORTED_ITEMS";
export const RESET_LISTING_STATES = "RESET_LISTING_STATES";
export const SET_NEXT_PATIENT_OBJECT = "SET_NEXT_PATIENT_OBJECT";
export const SET_FROM_CUSTOM_DATE_VALUE = "SET_FROM_CUSTOM_DATE_VALUE";
export const SET_TO_CUSTOM_DATE_VALUE = "SET_TO_CUSTOM_DATE_VALUE";

export const GET_ALL_PATIENTS_REQUEST = "GET_ALL_PATIENTS_REQUEST";
export const GET_ALL_PATIENTS_SUCCESS = "GET_ALL_PATIENTS_SUCCESS";
export const GET_ALL_PATIENTS_FAIL = "GET_ALL_PATIENTS_FAIL";
export const RESET_ALL_PATIENTS = "RESET_ALL_PATIENTS";

export const GET_PATIENT_OVERVIEW_SUMMARY_REQUEST =
  "GET_PATIENT_OVERVIEW_SUMMARY_REQUEST";
export const GET_PATIENT_OVERVIEW_SUMMARY_SUCCESS =
  "GET_PATIENT_OVERVIEW_SUMMARY_SUCCESS";
export const GET_PATIENT_OVERVIEW_SUMMARY_FAIL =
  "GET_PATIENT_OVERVIEW_SUMMARY_FAIL";
// export const RESET_PATIENT_OVERVIEW_SUMMARY = "RESET_PATIENT_OVERVIEW_SUMMARY";

export const GET_NEXT_PATIENT_REQUEST = "GET_NEXT_PATIENT_REQUEST";
export const GET_NEXT_PATIENT_SUCCESS = "GET_NEXT_PATIENT_SUCCESS";
export const GET_NEXT_PATIENT_FAIL = "GET_NEXT_PATIENT_FAIL";
export const RESET_NEXT_PATIENT = "RESET_NEXT_PATIENT";

export const GET_AGENCY_PATIENTS_REQUEST = "GET_AGENCY_PATIENTS_REQUEST";
export const GET_AGENCY_PATIENTS_SUCCESS = "GET_AGENCY_PATIENTS_SUCCESS";
export const GET_AGENCY_PATIENTS_FAIL = "GET_AGENCY_PATIENTS_FAIL";
export const RESET_GET_AGENCY_PATIENTS = "RESET_GET_AGENCY_PATIENTS";

export const GET_UNPAGINATED_PATIENTS_REQUEST =
  "GET_UNPAGINATED_PATIENTS_REQUEST";
export const GET_UNPAGINATED_PATIENTS_SUCCESS =
  "GET_UNPAGINATED_PATIENTS_SUCCESS";
export const GET_UNPAGINATED_PATIENTS_FAIL = "GET_UNPAGINATED_PATIENTS_FAIL";
export const RESET_UNPAGINATED_PATIENTS = "RESET_UNPAGINATED_PATIENTS";

export const GET_A_PATIENT_BY_PID_REQUEST = "GET_A_PATIENT_BY_PID_REQUEST";
export const GET_A_PATIENT_BY_PID_SUCCESS = "GET_A_PATIENT_BY_PID_SUCCESS";
export const GET_A_PATIENT_BY_PID_FAIL = "GET_A_PATIENT_BY_PID_FAIL";
export const RESET_A_PATIENT_BY_PID = "RESET_A_PATIENT_BY_PID";

export const GET_PATIENT_AGENT_ROLES_REQUEST = "GET_PATIENT_AGENT_ROLES_REQUEST";
export const GET_PATIENT_AGENT_ROLES_SUCCESS = "GET_PATIENT_AGENT_ROLES_SUCCESS";
export const GET_PATIENT_AGENT_ROLES_FAIL = "GET_PATIENT_AGENT_ROLES_FAIL";
export const RESET_PATIENT_AGENT_ROLES = "RESET_PATIENT_AGENT_ROLES";

export const ADD_RECORD_CONSENT_REQUEST = "ADD_RECORD_CONSENT_REQUEST";
export const ADD_RECORD_CONSENT_SUCCESS = "ADD_RECORD_CONSENT_SUCCESS";
export const ADD_RECORD_CONSENT_FAIL = "ADD_RECORD_CONSENT_FAIL";
export const RESET_RECORD_CONSENT = "RESET_RECORD_CONSENT";

export const EQUIP_SETUP_REQUEST = "EQUIP_SETUP_REQUEST";
export const EQUIP_SETUP_SUCCESS = "EQUIP_SETUP_SUCCESS";
export const EQUIP_SETUP_FAIL = "EQUIP_SETUP_FAIL";
export const RESET_EQUIP_SETUP = "RESET_EQUIP_SETUP";

export const EDUCATION_SETUP_REQUEST = "EDUCATION_SETUP_REQUEST";
export const EDUCATION_SETUP_SUCCESS = "EDUCATION_SETUP_SUCCESS";
export const EDUCATION_SETUP_FAIL = "EDUCATION_SETUP_FAIL";
export const RESET_EDUCATION_SETUP = "RESET_EDUCATION_SETUP";

export const UNENROLL_PATIENT_REQUEST = "UNENROLL_PATIENT_REQUEST";
export const UNENROLL_PATIENT_SUCCESS = "UNENROLL_PATIENT_SUCCESS";
export const UNENROLL_PATIENT_FAIL = "UNENROLL_PATIENT_FAIL";
export const RESET_UNENROLL_PATIENT = "RESET_UNENROLL_PATIENT";

export const GET_TABS_COUNT_REQUEST = "GET_TABS_COUNT_REQUEST";
export const GET_TABS_COUNT_SUCCESS = "GET_TABS_COUNT_SUCCESS";
export const GET_TABS_COUNT_FAIL = "GET_TABS_COUNT_FAIL";
export const RESET_GET_TABS_COUNT = "RESET_GET_TABS_COUNT";

export const GET_CLIENT_PAINLOGS_REQUEST = "GET_CLIENT_PAINLOGS_REQUEST";
export const GET_CLIENT_PAINLOGS_SUCCESS = "GET_CLIENT_PAINLOGS_SUCCESS";
export const GET_CLIENT_PAINLOGS_FAIL = "GET_CLIENT_PAINLOGS_FAIL";

export const GET_LAST_LAB_DATE_REQUEST = "GET_LAST_LAB_DATE_REQUEST";
export const GET_LAST_LAB_DATE_SUCCESS = "GET_LAST_LAB_DATE_SUCCESS";
export const GET_LAST_LAB_DATE_FAIL = "GET_LAST_LAB_DATE_FAIL";

export const GET_PAIN_STATS_REQUEST = "GET_PAIN_STATS_REQUEST";
export const GET_PAIN_STATS_SUCCESS = "GET_PAIN_STATS_SUCCESS";
export const GET_PAIN_STATS_FAIL = "GET_PAIN_STATS_FAIL";

export const GET_MEDICINE_DATA_REQUEST = "GET_MEDICINE_DATA_REQUEST";
export const GET_MEDICINE_DATA_SUCCESS = "GET_MEDICINE_DATA_SUCCESS";
export const GET_MEDICINE_DATA_FAIL = "GET_MEDICINE_DATA_FAIL";
export const RESET_MEDICINE_DATA = "RESET_MEDICINE_DATA";

export const GET_CHART_PAINLOGS_REQUEST = "GET_CHART_PAINLOGS_REQUEST";
export const GET_CHART_PAINLOGS_SUCCESS = "GET_CHART_PAINLOGS_SUCCESS";
export const GET_CHART_PAINLOGS_FAIL = "GET_CHART_PAINLOGS_FAIL";

export const ADD_NEW_PATIENT_REQUEST = "ADD_NEW_PATIENT_REQUEST";
export const ADD_NEW_PATIENT_SUCCESS = "ADD_NEW_PATIENT_SUCCESS";
export const ADD_NEW_PATIENT_FAIL = "ADD_NEW_PATIENT_FAIL";

export const UPDATE_PATIENT_REQUEST = "UPDATE_PATIENT_REQUEST";
export const UPDATE_PATIENT_SUCCESS = "UPDATE_PATIENT_SUCCESS";
export const UPDATE_PATIENT_FAIL = "UPDATE_PATIENT_FAIL";
export const UPDATE_PATIENT_RESET = "UPDATE_PATIENT_RESET";

export const DELETE_PATIENT_REQUEST = "DELETE_PATIENT_REQUEST";
export const DELETE_PATIENT_SUCCESS = "DELETE_PATIENT_SUCCESS";
export const DELETE_PATIENT_FAIL = "DELETE_PATIENT_FAIL";
export const RESET_DELETE_PATIENT = "RESET_DELETE_PATIENT";

export const GENERATE_EVIDENCE_REQUEST = "GENERATE_EVIDENCE_REQUEST";
export const GENERATE_EVIDENCE_SUCCESS = "GENERATE_EVIDENCE_SUCCESS";
export const GENERATE_EVIDENCE_FAIL = "GENERATE_EVIDENCE_FAIL";
export const RESET_GENERATE_EVIDENCE = "RESET_GENERATE_EVIDENCE";

// DASHBOARD ANALYTICS
export const GET_DASHBOARD_ANALYTICS_REQUEST =
  "GET_DASHBOARD_ANALYTICS_REQUEST";
export const GET_DASHBOARD_ANALYTICS_SUCCESS =
  "GET_DASHBOARD_ANALYTICS_SUCCESS";
export const GET_DASHBOARD_ANALYTICS_FAIL = "GET_DASHBOARD_ANALYTICS_FAIL";

export const GET_DASHBOARD_ALERTS_REQUEST = "GET_DASHBOARD_ALERTS_REQUEST";
export const GET_DASHBOARD_ALERTS_SUCCESS = "GET_DASHBOARD_ALERTS_SUCCESS";
export const GET_DASHBOARD_ALERTS_FAIL = "GET_DASHBOARD_ALERTS_FAIL";

export const GET_UNREAD_CHAT_MESSAGES_REQUEST =
  "GET_UNREAD_CHAT_MESSAGES_REQUEST";
export const GET_UNREAD_CHAT_MESSAGES_SUCCESS =
  "GET_UNREAD_CHAT_MESSAGES_SUCCESS";
export const GET_UNREAD_CHAT_MESSAGES_FAIL = "GET_UNREAD_CHAT_MESSAGES_FAIL";

export const GET_PIE_CHART_STATS_REQUEST = "GET_PIE_CHART_STATS_REQUEST";
export const GET_PIE_CHART_STATS_SUCCESS = "GET_PIE_CHART_STATS_SUCCESS";
export const GET_PIE_CHART_STATS_FAIL = "GET_PIE_CHART_STATS_FAIL";
export const RESET_PIE_CHART_STATS = "RESET_PIE_CHART_STATS";

export const ADD_PATIENT_DETAILS_REQUEST = "ADD_PATIENT_DETAILS_REQUEST";
export const ADD_PATIENT_DETAILS_SUCCESS = "ADD_PATIENT_DETAILS_SUCCESS";
export const ADD_PATIENT_DETAILS_FAIL = "ADD_PATIENT_DETAILS_FAIL";
export const RESET_ADD_PATIENT_DETAILS = "RESET_ADD_PATIENT_DETAILS";

export const ADD_PATIENT_PASSWORD_REQUEST = "ADD_PATIENT_PASSWORD_REQUEST";
export const ADD_PATIENT_PASSWORD_SUCCESS = "ADD_PATIENT_PASSWORD_SUCCESS";
export const ADD_PATIENT_PASSWORD_FAIL = "ADD_PATIENT_PASSWORD_FAIL";
export const RESET_ADD_PATIENT_PASSWORD = "RESET_ADD_PATIENT_PASSWORD";

export const REENROLL_PATIENT_REQUEST = "REENROLL_PATIENT_REQUEST";
export const REENROLL_PATIENT_SUCCESS = "REENROLL_PATIENT_SUCCESS";
export const REENROLL_PATIENT_FAIL = "REENROLL_PATIENT_FAIL";
export const RESET_REENROLL_PATIENT = "RESET_REENROLL_PATIENT";

export const GET_PINNED_NOTES_REQUEST = "GET_PINNED_NOTES_REQUEST";
export const GET_PINNED_NOTES_SUCCESS = "GET_PINNED_NOTES_SUCCESS";
export const GET_PINNED_NOTES_FAIL = "GET_PINNED_NOTES_FAIL";

export const DELETE_PATIENT_NOTE_REQUEST = "DELETE_PATIENT_NOTE_REQUEST";
export const DELETE_PATIENT_NOTE_SUCCESS = "DELETE_PATIENT_NOTE_SUCCESS";
export const DELETE_PATIENT_NOTE_FAIL = "DELETE_PATIENT_NOTE_FAIL";

export const GET_MINIMISED_NOTE_REQUEST = "GET_MINIMISED_NOTE_REQUEST";
export const GET_MINIMISED_NOTE_SUCCESS = "GET_MINIMISED_NOTE_SUCCESS";
export const GET_MINIMISED_NOTE_FAIL = "GET_MINIMISED_NOTE_FAIL";
export const RESET_MINIMISED_NOTE = "RESET_MINIMISED_NOTE";

export const GET_PATIENT_REPORTS_REQUEST = "GET_PATIENT_REPORTS_REQUEST";
export const GET_PATIENT_REPORTS_SUCCESS = "GET_PATIENT_REPORTS_SUCCESS";
export const GET_PATIENT_REPORTS_FAIL = "GET_PATIENT_REPORTS_FAIL";

export const CREATE_ENROLMENT_REQUEST = "CREATE_ENROLMENT_REQUEST";
export const CREATE_ENROLMENT_SUCCESS = "CREATE_ENROLMENT_SUCCESS";
export const CREATE_ENROLMENT_FAIL = "CREATE_ENROLMENT_FAIL";
export const RESET_CREATE_ENROLMENT = "RESET_CREATE_ENROLMENT";

export const UN_ENROLMENT_PROGRAM_REQUEST = "UN_ENROLMENT_PROGRAM_REQUEST";
export const UN_ENROLMENT_PROGRAM_SUCCESS = "UN_ENROLMENT_PROGRAM_SUCCESS";
export const UN_ENROLMENT_PROGRAM_FAIL = "UN_ENROLMENT_PROGRAM_FAIL";
export const RESET_UN_ENROLMENT_PROGRAM = "RESET_UN_ENROLMENT_PROGRAM";

export const GET_ENROLMENTS_LIST_REQUEST = "GET_ENROLMENTS_LIST_REQUEST";
export const GET_ENROLMENTS_LIST_SUCCESS = "GET_ENROLMENTS_LIST_SUCCESS";
export const GET_ENROLMENTS_LIST_FAIL = "GET_ENROLMENTS_LIST_FAIL";
// export const RESET_GET_ENROLMENTS_LIST = "RESET_GET_ENROLMENTS_LIST";

export const LOG_ENROLMENT_VISIT_REQUEST = "LOG_ENROLMENT_VISIT_REQUEST";
export const LOG_ENROLMENT_VISIT_SUCCESS = "LOG_ENROLMENT_VISIT_SUCCESS";
export const LOG_ENROLMENT_VISIT_FAIL = "LOG_ENROLMENT_VISIT_FAIL";
export const RESET_LOG_ENROLMENT_VISIT = "RESET_LOG_ENROLMENT_VISIT";

export const PCM_ENROLMENT_CONSENT_REQUEST = "PCM_ENROLMENT_CONSENT_REQUEST";
export const PCM_ENROLMENT_CONSENT_SUCCESS = "PCM_ENROLMENT_CONSENT_SUCCESS";
export const PCM_ENROLMENT_CONSENT_FAIL = "PCM_ENROLMENT_CONSENT_FAIL";
export const RESET_PCM_ENROLMENT_CONSENT = "RESET_PCM_ENROLMENT_CONSENT";

export const UPDATE_CONTACT_NUMBER_REQUEST = "UPDATE_CONTACT_NUMBER_REQUEST";
export const UPDATE_CONTACT_NUMBER_SUCCESS = "UPDATE_CONTACT_NUMBER_SUCCESS";
export const UPDATE_CONTACT_NUMBER_FAIL = "UPDATE_CONTACT_NUMBER_FAIL";
export const RESET_UPDATE_CONTACT_NUMBER = "RESET_UPDATE_CONTACT_NUMBER";

export const GET_ENROLMENT_TIMELINE_REQUEST = "GET_ENROLMENT_TIMELINE_REQUEST";
export const GET_ENROLMENT_TIMELINE_SUCCESS = "GET_ENROLMENT_TIMELINE_SUCCESS";
export const GET_ENROLMENT_TIMELINE_FAIL = "GET_ENROLMENT_TIMELINE_FAIL";

export const UPDATE_MOBILE_PASSWORD_REQUEST = "UPDATE_MOBILE_PASSWORD_REQUEST";
export const UPDATE_MOBILE_PASSWORD_SUCCESS = "UPDATE_MOBILE_PASSWORD_SUCCESS";
export const UPDATE_MOBILE_PASSWORD_FAIL = "UPDATE_MOBILE_PASSWORD_FAIL";
export const RESET_UPDATE_MOBILE_PASSWORD = "RESET_UPDATE_MOBILE_PASSWORD";

export const GET_QOL_ANSWERS_REQUEST = "GET_QOL_ANSWERS_REQUEST";
export const GET_QOL_ANSWERS_SUCCESS = "GET_QOL_ANSWERS_SUCCESS";
export const GET_QOL_ANSWERS_FAIL = "GET_QOL_ANSWERS_FAIL";

export const GET_BMI_RESPONSES_REQUEST = "GET_BMI_RESPONSES_REQUEST";
export const GET_BMI_RESPONSES_SUCCESS = "GET_BMI_RESPONSES_SUCCESS";
export const GET_BMI_RESPONSES_FAIL = "GET_BMI_RESPONSES_FAIL";

export const GET_PHQ_RESPONSES_REQUEST = "GET_PHQ_RESPONSES_REQUEST";
export const GET_PHQ_RESPONSES_SUCCESS = "GET_PHQ_RESPONSES_SUCCESS";
export const GET_PHQ_RESPONSES_FAIL = "GET_PHQ_RESPONSES_FAIL";

export const GET_ONCOLOGY_RESPONSES_REQUEST = "GET_ONCOLOGY_RESPONSES_REQUEST";
export const GET_ONCOLOGY_RESPONSES_SUCCESS = "GET_ONCOLOGY_RESPONSES_SUCCESS";
export const GET_ONCOLOGY_RESPONSES_FAIL = "GET_ONCOLOGY_RESPONSES_FAIL";
